import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { School } from "@mui/icons-material";
import meetSharif  from "../images/about_deb_bg.jpg";

const InvestingInPublicSchools = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetSharif })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <School sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Investing in Public Schools
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Sharif will work to alleviate overcrowding, pay
              our teachers and staff a competitive wage and keep our schools
              safe. Sharif has always been a champion for fully funding and
              prioritizing our high-quality public schools. Every year, she
              advocates for funding new school construction, small class sizes,
              and programs that prepare students for success.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Increased funding sources for school construction by raising the fee on new residential development." />
              <Bullet text="Enabled more financial resources to be used for smaller class sizes and higher teacher compensation." />
              <Bullet text="Pushed for the school district’s massive deferred maintenance to become a funding priority in the Capital budget." />
              <Bullet text="Supported the construction of new school buildings to relieve overcrowding." />
              <Bullet text="Supported funding for Faulkner Ridge to be repurposed into a pre-kindergarten center." />
              <Bullet text="Fought to strengthen growth controls (APFO) so that the school district has enough time to build capacity for students from new developments." />
              <Bullet text="Voted for $15 million for land acquisition for high school 14 in Elkridge in the FY24 budget." />
              <Bullet text="Partnered with the local PTAs to assist with safe walking routes to school, reduce speeding in school zones, and address other school safety issues." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default InvestingInPublicSchools;
